import React, { useState } from "react";
import PropTypes from "prop-types";

import { MenuItem, Select } from "@mui/material";

function ControlledSelect(props) {
  const [controlledValues, setControlledValues] = useState(props.values);
  const [controlledValue, setControlledValue] = useState(props.value);

  return (
    <Select
      color={"primary"}
      id={props.id}
      inputProps={{ ...props.inputProps, name: props.name }}
      multiple={props.multiple}
      onChange={(e) => {
        if (props.controlled) {
          if (props.multiple) {
            setControlledValues(e.target.value);
          } else {
            setControlledValue(e.target.value);
          }
        }
        props.onHandleValue(e.target.value);
      }}
      style={{ width: "100%" }}
      value={props.multiple ? controlledValues : controlledValue}
    >
      {props.options.map((option) => {
        return (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        );
      })}
    </Select>
  );
}

ControlledSelect.defaultProps = {
  multiple: false,
  controlled: true,
  inputProps: {},
};

ControlledSelect.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  onHandleValue: PropTypes.func,
  controlled: PropTypes.bool,
};

export default ControlledSelect;
